import React, { useEffect, useState } from 'react';
import { Col, Container, NavLink, Row } from 'react-bootstrap';
import { InputBox } from '../components/common';
import { Link } from 'react-router-dom';
import logo from '../images/2.png';
import validate from "../validations/FormValidationRules";
import useFormvalidation from '../validations/FormValidation'
import AuthAction from '../redux/actions/AuthAction';
import OrderAction from '../redux/actions/OrderAction';
import { useSelector, useDispatch } from "react-redux";
import { RecaptchaVerifier, signInWithPhoneNumber } from 'firebase/auth';
import { auth } from '../components/firebase/Setup';
import { Helmet } from 'react-helmet';
const Register = () => {
    const dispatch = useDispatch()
    const [currentStep, setcurrentStep] = useState(0);
    const [buttonstatus, setButtonstatus] = useState(false);
    const [user, setuser] = useState(null);
    const verification_status = useSelector(state => state.orderdetail.verification_status);
    const [formValues, setFormValues] = React.useState(

        localStorage.getItem("verification_method") == 1 ? {
            "name": "",
            "phone": "",
            "password": "",
            "otp": "",
            "category": 1
        }
            :
            {
                "name": "",
                "mailid": "",
                "password": "",
                "otp": "",
                "category": 1
            }




    );

    const { SignUp } = AuthAction();
    const { checkemail } = OrderAction();
    const { values, errors, setErrors, handleChange, handleSubmit } = useFormvalidation(
        handleNext,
        validate,
        formValues
    );

    async function awer() {
        if (currentStep == 0) {
            setButtonstatus(true)
            const recaptchaVerifier = new RecaptchaVerifier(auth, 'recaptcha', {});
            const phoneNumberWithCode = `+91${values.phone}`;
            const confirmation = await signInWithPhoneNumber(auth, phoneNumberWithCode, recaptchaVerifier);
            setcurrentStep(1)
            setuser(confirmation)
            setButtonstatus(false)
        } else {
            if (user) {
                try {
                    var confirmationResult = await user.confirm(values.otp);
                    if (confirmationResult) {
                        dispatch(SignUp(values, setErrors, setcurrentStep))
                        // setOtpVerified(true); 
                        // setEnter(false)
                    } else {
                        // setOtpVerified(false); 
                        // setEnter(true)
                        alert("OTP not verified");
                    }
                } catch (err) {
                    if (err.code === "auth/invalid-verification-code") {
                        setErrors({
                            otp: "Please enter a valid OTP."
                        })
                        // Handle invalid OTP
                    }
                }


            }
        }
    }


    useEffect(() => {
        if (verification_status != undefined) {
            if (Object.keys(verification_status).length > 0) {
                setErrors({
                    phone: verification_status.message
                })
            } else {
                awer()
            }

        }

    }, [verification_status])

    async function handleNext() {
        var input_data = {
            email: values.mailid,
            phone: values.phone
        }
        dispatch(checkemail(input_data))
        // if (currentStep == 1) {
        //     awer()
        // }



    }


    return (
        <Container>
              <Helmet>
        <title>{localStorage.getItem("title") +" - " + "Register"}</title>
        <link rel="canonical" href={window.location.origin + window.location.pathname} />
        {/* <GoogleAnalytics trackingId={"G-ZDTRF1HJ43"}/> */}
      </Helmet>
            <div className="register-container">
                <div className="register-wrap-container">
                    <div lg={5} className="right-side">
                        <h4 className="mb-4">Please Register Here </h4>
                        <Row>
                            <Col lg={6}>
                                <InputBox currentStep={currentStep} label={"Name"} id={"name"} handleChange={handleChange} errors={errors} />
                            </Col>
                            {
                                localStorage.getItem("verification_method") == 1 ?
                                    <Col lg={6}>
                                        <InputBox currentStep={currentStep} label={"Phone"} id={"phone"} handleChange={handleChange} errors={errors} />
                                    </Col>
                                    :
                                    <Col lg={6}>
                                        <InputBox currentStep={currentStep} label={"Email"} id={"mailid"} handleChange={handleChange} errors={errors} />
                                    </Col>
                            }


                            <Col lg={6}>
                                <InputBox currentStep={currentStep} label={"Password"} id={"password"} handleChange={handleChange} errors={errors} />
                            </Col>

                            {
                                currentStep == 1 &&
                                <Col lg={6}>
                                    <InputBox label={"Enter Otp"} id={"otp"} handleChange={handleChange} errors={errors} />
                                </Col>


                            }

                            {
                                currentStep != 1 &&
                                <Col lg={12} className='captcha-div'>

                                    <div id="recaptcha"></div>
                                </Col>
                            }

                        </Row>





                        <div className={`product-detail-buttongroup normal-register-btn ${buttonstatus ? "disable" : " "}`} >
                            <div className={`product-detail-button`} onClick={handleSubmit}>

                                {currentStep == 0 ? "Get Otp" : "Verify Otp"}


                            </div>
                        </div>

                        <div className='signupsec'>
                            <span className='DontAccount'>Already have an account, please</span>
                            <Link to="/login" className='signUpNavLink text-underline-none'>Sign In</Link>
                        </div>
                        <div className='signupsec navlink-2'>
                            <span className='DontAccount'>Buying for Business</span>
                            <Link to="/buisness-register" className='signUpNavLink text-underline-none'>Create a business account</Link>
                        </div>

                    </div>
                </div>

            </div>
        </Container>



    );
};

export default Register;